const indexItems = [
  { title: '顶流明星塌房事件全纪录', desc: '2025年娱乐圈最大震荡，多位顶流艺人被扒出丑闻，17吃瓜网全程追踪', icon: 'ri-file-list-3-line' },
  { title: '网红圈偷税漏税深度调查', desc: '17吃瓜黑料网独家梳理近年网红涉税案件，揭开高收入主播背后的财富密码', icon: 'ri-money-cny-circle-line' },
  { title: '选秀节目造假黑幕大起底', desc: '从投票数据到选手背景，17黑料吃瓜为你还原选秀综艺的真实面目', icon: 'ri-spy-line' },
  { title: '娱乐圈恋情时间线盘点', desc: '明星爆料合集：那些被拍到的秘密约会、地下恋情和惊人反转', icon: 'ri-heart-pulse-line' },
  { title: '综艺节目现场事故合集', desc: '惊险、尴尬、离奇——那些被镜头记录下的综艺意外瞬间', icon: 'ri-alert-line' },
  { title: '经纪公司霸王条款揭秘', desc: '17c吃瓜黑料爆料独家获取多家经纪公司内部合同，艺人的真实处境令人唏嘘', icon: 'ri-file-warning-line' },
  { title: '娱乐圈边缘人物生存报告', desc: '替身、群演、幕后工作者——那些被聚光灯忽略的行业底层真实故事', icon: 'ri-user-voice-line' },
  { title: '年度十大吃瓜事件回顾', desc: '内幕吃瓜年度盘点，回顾那些让我们熬夜追更的惊天大瓜和反转剧情', icon: 'ri-award-line' },
];

export default function Index() {
  return (
    <section id="index" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1160px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 md:h-8 rounded-full bg-accent-500"></div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            专题合集
          </h2>
          <span className="text-xs text-foreground-400 mt-1 whitespace-nowrap">· 深度专题精选</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div
              key={item.title}
              className="rounded-xl bg-background-50 border border-background-200/70 p-5 md:p-6 hover:border-primary-200 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${item.icon} text-lg md:text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 mb-2 line-clamp-1">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}